import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
 countObjectUseCase,
 deleteObjectUseCase,
 findObjectUseCase,
 upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import SalaryGradePresenter from "./SalaryGradePresenter";
import { DialogConfirmation } from "../../../components/common/Converter";
import InputFactory from "../../../components/InputFactory";
import Progress from "../../../components/Progress";
import ProgressDialog from "../../../components/common/ProgressDialog";

class SalaryGradePage extends BaseListPage {
 constructor(props) {
   super(props);
   this.presenter = new SalaryGradePresenter(
     this,
     findObjectUseCase(),
     countObjectUseCase(),
     deleteObjectUseCase(),
     upsertUseCase()
   );
   this.state = { 
     objects: [], 
     count: 0, 
     limit: 10, 
     current: 1,
     rawExcelData: [],
     employees: [],
     showProgressModal: false,
     saveProgress: 0,
     savedCount: 0,
     totalCount: 0
   };
   this.fileInputRef = React.createRef();
 }

 getCollectionName() {
   return "salary_grade";
 }

 async handleAddSalary() {
   this.navigateTo(`/form/${this.getCollectionName()}`);
 }

 async handleDeleteData(data) {
   // await this.presenter.deleteObjectUseCase.execute("employment_type", id);
   DialogConfirmation(data.id, this.getCollectionName(), () =>
     this.refetchData()
   );
 }

 // edit function
 async handleEditData(id) {
   this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
   // this.refetchData();
 }
 async handleViewData(object) {
   this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
   // this.refetchData();
 }

 async refetchData() {
   const objects = await this.presenter.getObjects();
   this.filterSubmit({});
   return objects;
 }

 onClickPagination(page) {
   this.presenter.setCurrentPage(page);
 }

 setObjects(objects) {
   this.setState({ objects });
 }

 setCurrent(current) {
   this.setState({ current });
 }

 handleChange(value, field, type) {
   this.presenter.onChangeFilter("String", value, field);
 }

 handleImportCSV() {
   this.presenter.handleImportCSV();
 }
 render() {
   const schema = this.getSchema(this.getCollectionName());
   const { objects, loading, current, limit, count, rawExcelData  } = this.state;

   if (!schema) return <Progress />;
   return (
     <>
       <div className="overflow-auto" style={{ marginTop: "5rem" }}>
         <InfiniteScroll
           className="h-100"
           loadMore={this.loadMore.bind(this)}
           // hasMore={!progress && count > objects.length}
         >
           <div className="p-3 p-lg-4">
             <div
               className="d-flex mb-4"
               style={{ borderBottom: "1.5px solid #d3d3d3" }}
             >
               <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                 You are here: Home {">"} Reference Table {">"}{" "}
                 <span
                   style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                 >
                   {schema.label}
                 </span>
               </p>
             </div>
             <CardView style={{ borderRadius: 0 }}>
               <Search
                 schemas={this.getSchemas()}
                 onSubmit={this.searchSubmit.bind(this)}
                 fields={schema.fields}
               />

               <div className="row p-2">
                 {Object.keys(schema.filters || {}).map((field) => {
                   let { type, ...options } = schema.filters[field];
                   return (
                     <div className="col-lg-4 p-1">
                       <InputFactory
                         key={field}
                         type={type}
                         field={field}
                         where={{}}
                         onChange={this.handleChange.bind(this)}
                         {...options}
                       />
                     </div>
                   );
                 })}
               </div>
             </CardView>

             <div
               style={{
                 marginTop: "20px",
                 width: "100%",
               }}
             >
               <CardView style={{ borderRadius: 0 }}>
                 <div className="d-flex align-items-center">
                   <h4 className="text-primary">{schema.label}</h4>
                   <div
                     style={{ marginLeft: "auto" }}
                     className="d-flex flex-column flex-sm-row gap-2 align-items-stretch align-items-sm-center"
                   >
                     <div className="flex-grow-1" style={{ minWidth: 220 }}>
                       <input
                         type="file"
                         accept=".xlsx,.xls,.csv"
                         className="form-control w-100"
                         onChange={(e) => this.presenter.handleExcelUpload(e)}
                         required={true}
                       />
                     </div>
                     <div className="d-flex gap-2 flex-wrap">
                     <Button 
                       className="btn bg-white border border-primary text-primary"
                     onClick={() => this.handleImportCSV()}
                     >
                       <i className="bi bi-box-arrow-in-down" /> Import
                     </Button>
                     <Button
                       onClick={this.handleAddSalary.bind(this)}
                       // onClick={this.onClickAdd.bind(this)}
                     >
                       <i className="bi bi-plus-lg" /> New {schema.label}
                     </Button>
                     </div>
                   </div>
                 </div>
               </CardView>
             </div>

             <Table
               viewObject={this.handleViewData.bind(this)}
               objectId={this.handleDeleteData.bind(this)}
               editId={this.handleEditData.bind(this)}
               progress={loading}
               refetch={this.refetchData.bind(this)}
               fields={schema.fields}
               objects={objects}
               collection={schema}
               count={count}
               limit={limit}
               current={current}
               loadPagination={this.onClickPagination.bind(this)}
               actionsList={[
                 {
                   label: <i className="bi bi-three-dots-vertical" />,
                   actionType: "common",
                 },
               ]}
               // selectable
               // collapsable
               excludeFields={Object.keys(schema.fields).reduce(
                 (acc, key) => {
                   const options = schema.fields[key];
                   if (options.read === false) {
                     acc.push(key);
                   }
                   switch (options._type || options.type) {
                     case "Relation":
                     case "Array":
                     case "Object":
                     case "File":
                       acc.push(key);
                       break;
                     default:
                   }
                   return acc;
                 },
                 ["id", "Created At", "Updated At"]
               )}
               onClickItem={this.onClickItem.bind(this)}
             />
           </div>
         </InfiniteScroll>
       </div>
       {this.state.showProgressModal && (
         <ProgressDialog
           saveProgress={this.state.saveProgress}
           savedCount={this.state.savedCount}
           totalCount={this.state.totalCount}
           title="Importing Salary Grades"
           processingMessage="Processing salary grade data..."
           successMessage="Salary grades imported successfully!"
         />
       )}
     </>
   );
 }
}

export default withRouter(SalaryGradePage);

